import { Component, computed, input, output } from '@angular/core';
import { IconComponent } from '@components/icon/icon.component';
import { ImageComponent } from '@components/image/image.component';
import { SearchResult, SearchResultType } from '@interfaces/search-result.interface';
import { GetImagePathPipe } from '@pipes/get-image-path/get-image-path.pipe';

@Component({
  selector: 'app-search-result-row',
  imports: [GetImagePathPipe, IconComponent, ImageComponent],
  templateUrl: './search-result-row.component.html',
  styleUrl: './search-result-row.component.scss'
})
export class SearchResultRowComponent {
  private static readonly TYPE_META: Record<SearchResultType, { icon: string; badge: string }> = {
    news: { icon: 'news-black.svg', badge: 'News' },
    product: { icon: 'category.svg', badge: 'Produkt' },
    folder: { icon: 'briefcase.svg', badge: 'Beratungsmappe' }
  };
  public active = input(false);
  public item = input.required<SearchResult>();
  public selected = output<SearchResult>();
  public readonly typeIcon = computed(() => SearchResultRowComponent.TYPE_META[this.item().type].icon);
  public readonly typeBadge = computed(() => SearchResultRowComponent.TYPE_META[this.item().type].badge);

  public onSelect(): void {
    this.selected.emit(this.item());
  }
}
